import { ActivityAlertSettingsDto } from "@core/data/dto/activity-alert-settings.dto";
import { ActivityAlertSettings } from "@core/domain/models/activity-alert-settings.model";
import { injectable } from "inversify";

@injectable()
export class ActivityAlertSettingsMapper {
    map(dto: ActivityAlertSettingsDto | null): ActivityAlertSettings | null {
        if (!dto) return null;

        return new ActivityAlertSettings(
            dto.enableInApp ?? true,
            dto.enableEmail ?? true,
            dto.alertDue7d ?? true,
            dto.alertDue1d ?? true,
            dto.alertDueToday ?? true,
            dto.alertOverdue ?? true,
        );
    }

    toBody(model: ActivityAlertSettings): {
        enable_in_app: boolean;
        enable_email: boolean;
        alert_due_7d: boolean;
        alert_due_1d: boolean;
        alert_due_today: boolean;
        alert_overdue: boolean;
    } {
        return {
            enable_in_app: model.enableInApp,
            enable_email: model.enableEmail,
            alert_due_7d: model.alertDue7d,
            alert_due_1d: model.alertDue1d,
            alert_due_today: model.alertDueToday,
            alert_overdue: model.alertOverdue,
        };
    }
}
